// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"45756b47","391":"3a36fe38","392":"4b9b4e7d","453":"2fb8355c","469":"b174f06c","537":"e21de085","726":"4eb49f75","956":"ab7d2a7f"}[chunkId] + ".chunk.js";
};